<template>
  <div class="flex content-center">
    <SwitchGroup>
      <Switch
        v-model="value"
        :class="value ? 'bg-lime-600' : 'bg-gray-200'"
        class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-lime-500 focus:ring-offset-2"
      >
        <span
          :class="value ? 'translate-x-6' : 'translate-x-1'"
          class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
        />
      </Switch>
      <SwitchLabel class="pl-2">{{ label }}</SwitchLabel>
    </SwitchGroup>
  </div>
</template>

<script>
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";

export default {
  components: { Switch, SwitchGroup, SwitchLabel },
  props: ["modelValue", "label"],
  data() {
    return {
      value: this.modelValue,
    };
  },
  watch: {
    value: function (new_value) {
      this.$emit("change", new_value);
      this.$emit("update:modelValue", new_value);
    },
  },
};
</script>